import React from 'react';
import { playIcon } from '../utilities/constants';

const VideoTitle = ({ title, overview }) => {
  return (
    <div className="absolute inset-0 text-white flex items-end pointer-events-none">
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent z-10"></div>
      <div className="relative z-20 px-6 md:px-12 lg:px-24 pb-[15%] md:pb-[10%] w-full max-w-full pointer-events-auto">
        <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold">{title}</h1>
        <p className="hidden md:block w-full md:w-2/3 lg:w-1/2 xl:w-1/3 text-base md:text-lg py-3 line-clamp-3">{overview}</p>
        <div className="flex gap-2 md:gap-4 flex-wrap mt-2">
          <button className="flex items-center text-base md:text-xl py-1 md:py-2 px-3 md:px-6 bg-white rounded-lg text-black hover:bg-opacity-80">
            <img className="w-5 h-5 md:w-6 md:h-6 mr-2" src={playIcon} alt="Play icon" />
            Play
          </button>
          <button className="hidden md:inline-block text-base md:text-xl py-1 md:py-2 px-3 md:px-6 bg-gray-500 bg-opacity-50 rounded-lg text-white hover:bg-opacity-80">
            More Info
          </button>
        </div>
      </div>
    </div>
  );
};

export default VideoTitle;